<!--
Example:
<badge mark="8,5"/>
-->

<template>
   <svg xmlns="http://www.w3.org/2000/svg" :width="svgSize" :height="svgSize">

      <g :transform="transform">

         <!-- outer star shape -->
         <path :d="starPath" :stroke="backColor" :fill="backColor" class="star"></path>
         <!-- inner circle -->
         <path :d="circlePath" :stroke="frontColor" :fill="backColor" class="circle" ></path>
         <!-- central mark line -->
         <path :d="linePath" :stroke="frontColor" class="line"></path>

         <text :x="11.0" :y="11.5" :fill="frontColor" class="mark">{{ mark }}</text>
         <text :x="12.5" :y="19.0" :fill="frontColor" class="mark">10</text>

      </g>

   </svg>
</template>


<script>

  const BASESIZE = 24.

   export default {

      props: {
         size: {
            type: [Number, String],
            default: 120.
         },
         mark: {
            type: String,
            default: "10"
         },
         backColor: {
            type: String,
            default: "#a3937a"
         },
         frontColor: {
            type: String,
            default: "white"
         },
      },

      computed: {
         basesize () {
            return BASESIZE
         },
         scale () {
            return this.size / BASESIZE
         },
         svgSize () {
            return (10 + BASESIZE*this.scale) + 'px'
         },
         transform () {
            return `translate(5, 5) scale(${this.scale})`
         },

         starPath () {
            return "M10.151 1.013c.931-1.221 2.769-1.219 3.697 0 .617.809 1.688 1.123 2.643.776 1.442-.524 2.987.471 3.111 1.999.081 1.014.812 1.856 1.803 2.081 1.496.339 2.259 2.011 1.536 3.364-.479.896-.32 2.001.393 2.726 1.075 1.095.812 2.913-.526 3.66-.889.495-1.352 1.509-1.145 2.505.313 1.498-.888 2.891-2.421 2.794-1.015-.063-1.953.54-2.317 1.489-.546 1.429-2.31 1.952-3.548 1.042-.819-.602-1.935-.602-2.754 0-1.232.907-2.998.393-3.548-1.042-.363-.949-1.302-1.552-2.316-1.489-1.53.096-2.733-1.292-2.422-2.794.207-.996-.256-2.01-1.144-2.505-1.346-.751-1.598-2.572-.526-3.66.712-.725.871-1.83.392-2.726-.724-1.354.041-3.024 1.536-3.364.991-.225 1.722-1.067 1.804-2.081.122-1.528 1.67-2.522 3.11-1.999.956.347 2.026.033 2.642-.776z"
         },
         circlePath () {
            return "M 6.308363,19.379611 A 9.2306128,9.1798944 0 0 1 4.7182868,6.5108235 9.2306128,9.1798944 0 0 1 17.65403,4.8963053 9.2306128,9.1798944 0 0 1 19.310819,17.756766 9.2306128,9.1798944 0 0 1 6.3836209,19.437609"
         },
         linePath () {
            return "M 7.6223714,13.932717 16.754836,12.134988"
         },
      },
   }

</script>

<style scoped>
.nutri-galva {
  cursor: pointer;
}

.text-anchor-middle {
  text-anchor: middle;
}

.star {
}

.circle {
  opacity:1;
  fill-opacity:1;
  stroke-width:0.14720318;
  stroke-miterlimit:4;
  stroke-dasharray:none;
  stroke-opacity:1;
}

.line {
   fill:none;
   fill-rule:evenodd;
   stroke-width:0.2;
   stroke-linecap:butt;
   stroke-linejoin:miter;
   stroke-miterlimit:4;
   stroke-dasharray:none;
   stroke-opacity:1;
}

.mark {
  font-style:normal;
  font-variant:normal;
  font-weight:300;
  font-stretch:normal;
  font-size:6.51522875px;
  line-height:125%;
  font-family:Helvetica;
  text-align:start;
  letter-spacing:0px;
  word-spacing:0px;
  writing-mode:lr-tb;
  text-anchor:middle;
  fill-opacity:1;
  stroke:none;
  stroke-width:1px;
  stroke-linecap:butt;
  stroke-linejoin:miter;
  stroke-opacity:1;
}
</style>



// WEBPACK FOOTER //
// Badge.vue?68e08d8f